<script>
import EventEmitter from 'eventemitter3'

const EE = new EventEmitter()
const upButton = document.getElementById('t')
upButton.addEventListener('click', () => EE.emit('setToken'))

export default {
  created() {
    EE.on('setToken', this.init)
  },
  destroyed() {
    EE.removeListener('setToken', this.init)
  },
  methods: {
    async init() {
      try {
        await this.getPageData()
      } catch (error) {
        console.log(error)
      }
    },
    getPageData() {
      const { timing: token, count: shopId } = document.getElementById('t').dataset
      this.$store.dispatch('auth/setToken', { token })
      // shopIdは事前注文時のみ設定される
      if (shopId) this.$store.dispatch('seat/setShopId', Number(shopId))
    },
  },
  render(h) {
    return h() // avoid empty template warning message
  },
}
</script>
